import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { VideoService } from './service/video.service';


@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})

export class VideoComponent implements OnInit {

  @Input() public videoUrl!: string;
  @Input() public posterUrl!: string;
  @Input() public id!: string;

  @ViewChild('videoPlayer', { static: false }) public videoplayer!: ElementRef;
  public isPlay = false;

  constructor(private videoService: VideoService) {}

  public ngOnInit() {
    this.videoService.pauseOrPlayVideo$.subscribe(() => {
      const video: any = document.getElementById('my_video_1');

      video.currentTime = 0;
      this.pause();
    });
  }

  public toggleVideo(_event: any) {
    this.videoplayer.nativeElement.play();
  }

  public playPause() {
    const myVideo: any = document.getElementById('my_video_1');
    if (myVideo.paused){ 
      myVideo.play()
    }
    else {
      myVideo.pause()
    }
  }

  public pause() {
    const myVideo: any = document.getElementById('my_video_1');

    myVideo.pause();
  }

  public restart() {
    const video: any = document.getElementById('my_video_1');
    video.currentTime = 0;
  }
}
